/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Admin_Settings_Test_TitleInputs */

const en_admin_settings_test_title = /** @type {(inputs: Admin_Settings_Test_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Test ${i?.group}`)
};

const zh_admin_settings_test_title = /** @type {(inputs: Admin_Settings_Test_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`测试 ${i?.group}`)
};

/**
* | output |
* | --- |
* | "Test {group}" |
*
* @param {Admin_Settings_Test_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_title = /** @type {((inputs: Admin_Settings_Test_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_test_title(inputs)
	return zh_admin_settings_test_title(inputs)
});
export { admin_settings_test_title as "admin.settings.test.title" }